export default __webpack_public_path__ + "static/media/avatar.a63f7fc2.svg";